export type MouseType = 'left' | 'right' | 'middle' | 'scroll';

const MOUSE_FILLS: Record<MouseType, { left: string; right: string; middle: string }> = {
  left: { left: 'currentColor', right: 'none', middle: 'none' },
  right: { left: 'none', right: 'currentColor', middle: 'none' },
  middle: { left: 'none', right: 'none', middle: 'currentColor' },
  scroll: { left: 'none', right: 'none', middle: 'currentColor' },
};

export const MouseIcon = ({ type }: { type: MouseType }) => {
  const f = MOUSE_FILLS[type];
  return (
    <svg viewBox="0 0 24 32" class="w-[1em] h-[1.2em]" aria-hidden="true">
      <rect
        x="4"
        y="4"
        width="16"
        height="24"
        rx="8"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <line x1="12" y1="4" x2="12" y2="16" stroke="currentColor" stroke-width="1" opacity="0.4" />
      <path d="M4.8 12 A7.2 7.2 0 0 1 12 4.8 V16 H4.8 Z" fill={f.left} opacity="0.5" />
      <path d="M19.2 12 A7.2 7.2 0 0 0 12 4.8 V16 H19.2 Z" fill={f.right} opacity="0.5" />
      <rect
        x="10.5"
        y="8"
        width="3"
        height="5"
        rx="1.5"
        fill={f.middle}
        stroke="currentColor"
        stroke-width="0.8"
      />
      {type === 'scroll' && (
        <>
          <path d="M12 6.5 L10.5 8 L13.5 8 Z" fill="currentColor" opacity="0.6" />
          <path d="M12 15 L10.5 13 L13.5 13 Z" fill="currentColor" opacity="0.6" />
        </>
      )}
    </svg>
  );
};
